import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "../style/HeroCarousel.css";
import "swiper/css/navigation";

// Le immagini vengono servite da /public/images per poter usare <picture> con media queries

function SlideImage({ alt, base, position = "center center", yNudge = 0 }) {
  // base: prefisso del file, es. "ghost_hunter_carousel" oppure "zombie_crushers_carousel"
  const p = (suffix) => `/images/${base}_${suffix}.webp`;

  return (
    <div className="slide">
      {/* layer di sfondo "blurred bleed" per ottenere full-width senza tagli visibili */}
      <div
        className="slide-bg"
        style={{ backgroundImage: `url(${p("2560x1440")})` }}
        aria-hidden="true"
      />
      <picture className="slide-fore">
        {/* Verticale (mobile in portrait) */}
        <source media="(orientation: portrait) and (max-width: 900px)" srcSet={p("1600x1400")} type="image/webp" />
        {/* Desktop ampio 1440p */}
        <source media="(min-width: 1800px)" srcSet={p("2560x1440")} type="image/webp" />
        {/* Desktop 1080p */}
        <source media="(min-width: 1200px)" srcSet={p("1920x1080")} type="image/webp" />
        {/* Fallback: usa 1920x1080 e lascia al browser lo scale-down */}
        <img
          className="slide-img"
          src={p("1920x1080")}
          alt={alt}
          loading="eager"
          style={{ objectPosition: position, transform: yNudge ? `translateY(${yNudge}px)` : undefined }}
        />
      </picture>
    </div>
  );
}

export default function HeroCarousel() {
  return (
    <section className="hero-carousel">
      <div className="hero-container">
        <div className="hero-viewport">
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            navigation={true}
            loop={true}
          >
            <SwiperSlide>
              <SlideImage base="ghost_hunter_carousel" alt="Ghost Hunter" />
            </SwiperSlide>
            <SwiperSlide>
              {/* micro-shift in basso di 1px per evitare il morso sul bordo superiore */}
              <SlideImage base="zombie_crushers_carousel" alt="Zombie Crushers" yNudge={1} />
            </SwiperSlide>
            {/* Aggiungi altre slide duplicando la riga e preparando i file */}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
